import React from 'react';
import { Stack, useTheme, useMediaQuery, SvgIcon } from '@mui/material';
import { CustomButton } from 'src/components/customButton/CustomButton';
import { ReactComponent as GoogleLogo } from 'src/assets/google-logo.svg';

interface IProps {
  onContinueWithEmail: () => void;
  onSignInWithGoogle: () => void;
  isLoading?: boolean;
}

export const InitialButtons: React.FC<IProps> = ({
  onContinueWithEmail,
  onSignInWithGoogle,
  isLoading = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack spacing={2} alignItems="start" width="100%">
      <CustomButton
        fullWidth={isMobile}
        isLoading={isLoading}
        onClick={onContinueWithEmail}
        label="Continue with email"
        testid="continue-with-email-button"
        color="primary"
        style={{
          width: isMobile ? '100%' : '228px',
          whiteSpace: 'nowrap',
          minWidth: '0',
        }}
      />

      <CustomButton
        fullWidth={isMobile}
        onClick={onSignInWithGoogle}
        label="Sign in with Google"
        testid="sign-in-with-google-button"
        color="white"
        startIcon={
          <SvgIcon
            inheritViewBox
            component={GoogleLogo}
            sx={{
              width: '20px',
              height: '20px',
            }}
          />
        }
        style={{
          width: isMobile ? '100%' : '228px',
          whiteSpace: 'nowrap',
          minWidth: '0',
        }}
      />
    </Stack>
  );
};
